import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.494 11.575 16.217 9.3l2.121-2.122 2.277 2.277a1.5 1.5 0 0 0 2.121-2.121L20.46 5.056 21.52 4a1.5 1.5 0 0 0-2.12-2.126L8.638 12.635a5.249 5.249 0 1 0 2.122 2.121l3.34-3.336 2.273 2.28a1.5 1.5 0 1 0 2.121-2.122Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.277 17.243a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0"
    }, null, -1)
  ]));
}
const interfaceLoginKey = { render };
export {
  interfaceLoginKey as default,
  render
};
//# sourceMappingURL=interface-login-key.svg.js.map
